/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type PaginatedDataImportList,
    PaginatedDataImportListFromJSON,
    PaginatedDataImportListToJSON,
} from '../models/PaginatedDataImportList';

export interface DataImportListRequest {
    ordering?: string;
    page?: number;
    pageSize?: number;
}

/**
 * 
 */
export class DataImportApi extends runtime.BaseAPI {

    /**
     * Creates request options for dataImportList without sending the request
     */
    async dataImportListRequestOpts(requestParameters: DataImportListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/data-import/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Viewset for the DataImport model.
     */
    async dataImportListRaw(requestParameters: DataImportListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDataImportList>> {
        const requestOptions = await this.dataImportListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDataImportListFromJSON(jsonValue));
    }

    /**
     * Viewset for the DataImport model.
     */
    async dataImportList(requestParameters: DataImportListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDataImportList> {
        const response = await this.dataImportListRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
